<template>
  <b-modal
    id="choose-template"
    :title="$translate('Choose Milestone Group')"
    hide-footer
    centered
    content-class="rounded-8"
    @hidden="clear"
    @show="init"
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 mb-n4">
        <Select v-model="template" :options="templateList" placeholder="Milestone group" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-between mt-3">
        <b-button variant="outline-secondary" size="lg" class="btn-delete-device mr-3 px-60" @click="close">
          {{ 'Close' | i18n }}
        </b-button>
        <b-button variant="outline-primary" size="lg" class="btn-delete-device px-60" :disabled="!template" @click="submit">
          {{ 'Save' | i18n }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Select from '../../../../common/select';
import api from '../../../../../api';
import Notification from '../../../../common/notification';

import { mapMilestonePayload } from '../../milestone/helpers';

export default {
  title: 'ChooseGroup',
  components: {
    Select,
  },
  props: {
    projectExist: {
      type: Boolean,
      default: false,
    },
    addMilestone: {
      type: Function,
      default: () => {},
    },
    loadProject: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      template: null,
      templateList: [],
      tempaltes: [],
    };
  },
  methods: {
    async init() {
      try {
        const responce = await api.milestoneGroup.get();
        this.tempaltes = responce.data;
        this.templateList = this.tempaltes.map((i) => ({ value: i.id, text: i.name }));
      } catch (e) {
        console.log('Error to det templates');
      }
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'choose-template');
    },
    clear() {
      this.template = null;
      this.templateList = [];
      this.tempaltes = [];
    },
    async submit() {
      try {
        const projectId = this.$route.params.id;

        const selectedGroup = this.tempaltes.find((i) => i.id == this.template);

        for (const index in selectedGroup.items) {
          const selectedTemplate = selectedGroup.items[index];
          const milestoneValue = selectedTemplate;

          const template = milestoneValue.template;

          if (!milestoneValue.template) {
            continue;
          }
          const fieldsValue = {
            ...(selectedTemplate.template.report ? selectedTemplate.template.report.fields : {}),
            ...selectedTemplate.template.fields,
          };

          milestoneValue.templateId = milestoneValue.template.id;

          const payloadBase = {
            ...milestoneValue,
            project: projectId,
            fields: template.fields.map((f) => ({ ...f, value: fieldsValue[f.key] })),
            remoteSupport: [],
            onSiteSupport: [],
          };

          if (this.projectExist) {
            const payload = mapMilestonePayload(payloadBase);
            await api.projectMilestones.create(payload);
            this.loadProject();
          } else {
            this.addMilestone({
              milestoneData: { ...milestoneValue, remoteSupport: [], onSiteSupport: [] },
              fieldsValue: fieldsValue,
              isNew: true,
              id: `${Math.round(Math.random() * 10000)}_${new Date().getTime()}`,
            });
          }
        }
        Notification({ type: 'success', message: this.$translate('success') });
        this.close();
      } catch (err) {
        Notification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

.px-60 {
  padding-left: 60px;
  padding-right: 60px;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
